import type { AppConfig } from './environment.model';

export const environment: AppConfig = {
  production: false,
  apiBaseUrl: 'https://iam-dev.kominfomajalengka.dev/api/v1',
  apiCatalogUrl: 'https://apikatalog-dev.kominfomajalengka.dev',
  oauth: {
    issuer: 'https://iam-dev.kominfomajalengka.dev',
    clientId: 'iam-web-console',
    redirectUri: 'https://iam-console-dev.kominfomajalengka.dev/auth/callback',
    scope: 'openid profile email',
    tokenEndpoint: 'https://iam-dev.kominfomajalengka.dev/oauth2/token',
    authorizeEndpoint: 'https://iam-dev.kominfomajalengka.dev/oauth2/authorize',
    userinfoEndpoint: 'https://iam-dev.kominfomajalengka.dev/oauth2/userinfo',
  },
};
